"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { useAdminAuth } from "@/lib/auth-context";
import { AdminSidebar } from "@/components/admin-sidebar";
import { AdminShellProvider } from "@/components/admin-shell-context";

export default function AdminSectionLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user, ready } = useAdminAuth();
  const router = useRouter();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    if (!ready) return;
    if (!user) {
      router.replace("/login");
    }
  }, [user, ready, router]);

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return null; // Will redirect
  }

  return (
    <AdminShellProvider value={{ mobileSidebarOpen, setMobileSidebarOpen }}>
      <div className="flex min-h-screen bg-background">
        <AdminSidebar className="hidden md:flex" />

        {mobileSidebarOpen && (
          <button
            type="button"
            aria-label="Close sidebar overlay"
            className="fixed inset-0 z-40 bg-black/40 md:hidden"
            onClick={() => setMobileSidebarOpen(false)}
          />
        )}

        <AdminSidebar
          className={`fixed inset-y-0 left-0 z-50 transition-transform duration-200 ease-out md:hidden ${
            mobileSidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
          onNavigate={() => setMobileSidebarOpen(false)}
        />

        <div className="flex min-w-0 flex-1 flex-col">{children}</div>
      </div>
    </AdminShellProvider>
  );
}
